import { Radio } from "lucide-react";

export function AuthShell({ children, title, subtitle }) {
  return (
    <div className="grid-desktop min-h-screen flex items-center justify-center p-6">
      <div className="floating-card w-full max-w-[420px] p-8 fade-in">
        <div className="flex items-center gap-3 mb-6">
          <div className="h-10 w-10 rounded-xl bg-primary/15 border border-primary/40 flex items-center justify-center text-primary">
            <Radio className="h-5 w-5" />
          </div>
          <div>
            <div className="overline-label">10-23 Suite · Dispatch</div>
            <h1 className="display text-2xl font-semibold leading-tight">CAD-Lite</h1>
          </div>
        </div>
        {title && <h2 className="display text-base font-semibold mb-1">{title}</h2>}
        {subtitle && <p className="text-sm text-muted-foreground mb-5">{subtitle}</p>}
        {children}
        <p className="mt-6 text-[11px] text-muted-foreground mono">Prototype for design and workflow testing — not for live emergency operations.</p>
      </div>
    </div>
  );
}
